import * as actionTypes from './actionTypes';

import { createActionObject, getNoArgDispatcherFunc } from '../../helpers/common';

import * as strings from '../../helpers/strings';

export const setCredentials = (email, otp) => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_CREDENTIALS,
    { 
      email,
      otp
    }
  )
);

export const setPassword = password => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_PASSWORD,
    {
      password,
      error: password ? "" : strings.msgPasswordRequired
    }
  )
)

export const setConfirmPassword = password => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_CONFIRM_PASSWORD,
    {
      password,
      error: password ? "" : strings.msgConfirmPasswordRequired
    }
  )
)

export const matchPassword = (password, confirmPassword) => dispatch => {
  if(password !== confirmPassword)
    dispatch(
      createActionObject(
        actionTypes.SET_CONFIRM_PASSWORD_ERROR,
        {
          error: strings.msgPasswordsDoNotMatch
        }
      )
    )
}

export const setAlertMessage = message => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_ALERT_MESSAGE,
    { message }
  )
)

export const toggleAlertDialog = getNoArgDispatcherFunc(actionTypes.TOGGLE_ALIERT_DIALOG);

export const resetSuccessFlag = getNoArgDispatcherFunc(actionTypes.RESET_SUCCESS_FLAG);